const ALWAYS_VISIBLE_FIELDS = ['h2', 'h3', 'nbr_windings'];

function ShowOptions(option, showAll) {
  if (option === undefined) return false;

  if (ALWAYS_VISIBLE_FIELDS.includes(option.field)) return true;

  const calculated = option.calculated;
  const disabled = calculated || option.options?.length === 1;

  if (
    (disabled && showAll !== 'all') ||
    (!option.priced && showAll === 'priced')
  )
    return false;
  return true;
}

export default ShowOptions;
